<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav aria-label="breadcrumb" *ngIf="!createSaleFromCourses">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
        &nbsp; / &nbsp;
        <li class="breadcrumb-item active">
          {{ 'general.create' | translate }}
        </li>
      </ol>
    </nav>

    <h1 class="page-header-title">
      {{ 'saleModule.createSale' | translate }}
    </h1>
  </header>
  <!-- End Page Header -->

  <!-- Step -->
  <ul class="step my-3 my-md-5 m-auto">
    <li
      (click)="activeTab = 'selectCustomer'"
      [ngClass]="{ active: activeTab === 'selectCustomer' }"
      class="step-item cursor-pointer"
    >
      <span class="step-content-wrapper">
        <span class="step-icon">1</span>
        <div class="step-content">
          <span class="step-title">
            {{ 'general.general' | translate }}
          </span>
        </div>
      </span>
    </li>
    <li
      (click)="activeTab = 'saleItems'"
      [ngClass]="{ active: activeTab === 'saleItems' }"
      class="step-item cursor-pointer"
    >
      <div class="step-content-wrapper">
        <span class="step-icon">2</span>
        <div class="step-content">
          <span class="step-title">
            {{ 'saleModule.addSaleItems' | translate }}
          </span>
        </div>
      </div>
    </li>
  </ul>
  <!-- End Step -->

  <div *ngIf="activeTab == 'selectCustomer'">
    <section class="card">
      <div class="card-header">
        <h3 class="card-title">
          {{ 'general.selectCustomer' | translate }}
        </h3>
      </div>
      <div class="card-body">
        <sale-form
          (onSubmit)="onCustomerSubmit($event)"
          [showSubmitButton]="false"
          [triggerSubmit$]="triggerSubmitSubject$"
          [isCreating]="true"
          [sale]="salePartial$ | async"
        >
        </sale-form>
        <hr />
        <h4 class="">
          {{ 'general.other' | translate }}
        </h4>
        <form [formGroup]="form">
          <div class="mb-3">
            <div>
              <label class="form-label">
                {{ 'general.internalNote' | translate }}
              </label>
            </div>

            <textarea
              class="form-control"
              formControlName="internalNote"
              rows="3"
              [attr.aria-invalid]="
                form.controls.internalNote.dirty &&
                form.controls.internalNote.invalid
                  ? 'true'
                  : null
              "
            ></textarea>
          </div>
          <div class="mb-4" *ngIf="isOrderNumberEnable">
            <label class="form-label">
              {{ 'saleModule.orderNumber' | translate }}
            </label>
            <input
              class="form-control"
              type="text"
              formControlName="orderNumber"
              [attr.aria-invalid]="
                form.controls.orderNumber.dirty &&
                form.controls.orderNumber.invalid
                  ? 'true'
                  : null
              "
            />
            <p
              class="invalid-feedback"
              role="alert"
              aria-atomic="true"
              *ngIf="
                form.controls.orderNumber.dirty &&
                form.controls.orderNumber.invalid
              "
            >
              {{ 'saleModule.orderNumber' | translate }}
              {{ 'general.isInvalid' | translate }}
            </p>
          </div>
        </form>
      </div>
    </section>
    <div class="form-footer">
      <button
        data-test-id="create-sale-general-form-next-button"
        (click)="onClickNext()"
        class="btn btn-primary btn-lg"
        [canSee]="[accessRights.Sales_write]"
        type="button"
      >
        {{ 'general.next' | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="activeTab == 'saleItems'">
    <section class="card">
      <ng-container
        *ngIf="!createSaleFromCourses && saleItemPage == 'selectType'"
      >
        <div class="card-header">
          <h3 class="card-title">
            {{ 'saleModule.createSaleItems' | translate }}
          </h3>
        </div>
        <div class="card-body">
          <div class="row mb-4" *ngIf="saleContext$ | async as saleContext">
            <div class="col-sm-auto mb-3 mb-sm-0">
              <div class="text-muted small">
                {{ 'general.customer' | translate }}
              </div>
              <div class="text-dark">{{ saleContext.customerName }}</div>
            </div>
            <div class="col-sm-auto mb-3 mb-sm-0">
              <div class="text-muted small">
                {{ 'saleModule.customerCategory' | translate }}
              </div>
              <div class="text-dark">
                {{
                  saleContext.customerCategory | customerCategoryName | async
                }}
              </div>
            </div>
            <div class="col-sm-auto">
              <div class="text-muted small">
                {{ 'organizationModule.organization' | translate }}
              </div>
              <div class="text-dark">{{ saleContext.organizationName }}</div>
            </div>
          </div>
          <div class="row g-3">
            <div class="col-sm-4 col-xl" [canSee]="[accessRights.Sales_write]">
              <button
                data-test-id="create-sale-form-general-add-booking-button"
                (click)="onClickAddBooking()"
                class="d-flex flex-column h-100 w-100 align-items-center py-3 border btn btn-ghost-primary"
                type="button"
              >
                <span class="m-3 d-block">
                  <i
                    role="img"
                    class="fa fa-calendar-day fa-2x text-primary"
                    aria-hidden="true"
                  ></i>
                </span>
                <span class="h3 text-dark d-block">
                  {{ 'bookingModule.booking' | translate | titlecase }}
                </span>
              </button>
            </div>
            <div
              class="col-sm-4 col-xl"
              [canSee]="[accessRights.Course_write]"
              *ngIf="environment.moduleConfigs.courseModule.isActive"
            >
              <button
                data-test-id="create-sale-form-general-add-course-button"
                (click)="onClickAddCourse()"
                class="d-flex flex-column h-100 w-100 align-items-center py-3 border btn btn-ghost-primary"
                type="button"
              >
                <span class="m-3 d-block">
                  <i
                    role="img"
                    class="fa fa-calendar-alt fa-2x text-primary"
                    aria-hidden="true"
                  ></i>
                </span>
                <span class="h3 text-dark d-block">
                  {{ 'courseModule.course' | translate | titlecase }}
                </span>
              </button>
            </div>
            <div class="col-sm-4 col-xl" [canSee]="[accessRights.Sales_write]">
              <button
                data-test-id="create-sale-form-general-add-subscription-button"
                class="d-flex flex-column h-100 w-100 align-items-center py-3 border btn btn-ghost-primary"
                type="button"
                (click)="onClickAddSubscription()"
              >
                <span class="m-3 d-block">
                  <i
                    role="img"
                    class="fa fa-credit-card fa-2x text-primary"
                    aria-hidden="true"
                  ></i>
                </span>
                <span class="h3 text-dark">
                  {{
                    'subscriptionModule.subscription' | translate | titlecase
                  }}
                </span>
              </button>
            </div>
            <div
              class="col-sm-4 col-xl"
              [canSee]="[accessRights.Sales_write]"
              *ngIf="environment.moduleConfigs.rentalModule.isActive"
            >
              <button
                data-test-id="create-sale-form-general-add-rental-button"
                class="d-flex flex-column h-100 w-100 align-items-center py-3 border btn btn-ghost-primary"
                type="button"
                (click)="onClickAddRental()"
              >
                <span class="m-3 d-block">
                  <i
                    role="img"
                    class="fa fa-suitcase fa-2x text-primary"
                    aria-hidden="true"
                  ></i>
                </span>
                <span class="h3 text-dark">
                  {{ 'rentalModule.rental' | translate | titlecase }}
                </span>
              </button>
            </div>

            <div class="col-sm-4 col-xl" *ngIf="isMultiDayEnabled">
              <button
                data-test-id="create-sale-general-form-add-multiple-sale-button"
                (click)="onClickAddMultiSaleItem()"
                class="d-flex flex-column h-100 w-100 align-items-center py-3 border btn btn-ghost-primary"
                [canSee]="[accessRights.Sales_write]"
                type="button"
              >
                <span class="m-3 d-block">
                  <i
                    role="img"
                    class="fa fa-shopping-cart fa-2x text-primary"
                    aria-hidden="true"
                  ></i>
                </span>
                <span class="h3 text-dark d-block">
                  {{ 'bookingModule.multiDay' | translate | titlecase }}
                </span>
              </button>
            </div>
            <div class="col-sm-4 col-xl" [canSee]="[accessRights.Sales_write]">
              <button
                data-test-id="create-sale-form-general-add-unpaid-booking-button"
                class="d-flex flex-column h-100 w-100 align-items-center py-3 border btn btn-ghost-primary"
                type="button"
                (click)="onClickAddUnpaidBookings()"
              >
                <span class="m-3 d-block">
                  <i
                    role="img"
                    class="fa fa-money-bill fa-2x text-primary"
                    aria-hidden="true"
                  ></i>
                </span>
                <span class="h3 text-dark d-block">
                  {{ 'saleModule.unpaidBookings' | translate }}
                </span>
              </button>
            </div>
            <div class="col-sm-4 col-xl" [canSee]="[accessRights.Sales_write]">
              <button
                data-test-id="create-sale-form-general-other-product-button"
                class="d-flex flex-column h-100 w-100 align-items-center py-3 border btn btn-ghost-primary"
                (click)="onClickAddSaleItem()"
                type="button"
              >
                <span class="m-3 d-block">
                  <i
                    role="img"
                    class="fa fa-cube fa-2x text-primary"
                    aria-hidden="true"
                  ></i>
                </span>
                <span class="h3 text-dark d-block">
                  {{ 'saleModule.otherProduct' | translate }}
                </span>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="(saleItemPartials$ | async)?.length > 0">
          <dms-table
            [tableData]="saleItemPartials$ | async"
            [tableType]="'saleItems'"
            [hideEdit]="true"
            [salePartial]="true"
            (onDeletePartialRow)="onClickDelete($event)"
            (onClickRow)="onClickRow($event)"
            (onClickDelete)="onClickDelete($event)"
            (onBulkAction)="onBulkAction($event)"
          >
          </dms-table>

          <div class="card-footer text-end h4 mb-0">
            {{ 'general.total' | translate }}
            {{ saleItemPartialsTotal$ | async | currency }}
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="!createSaleFromCourses && saleItemPage != 'selectType'"
      >
        <div class="card-header">
          <h3 class="card-title" *ngIf="saleItemPage == 'booking'">
            {{ 'bookingModule.booking' | translate | titlecase }}
          </h3>
          <h3 class="card-title" *ngIf="saleItemPage == 'course'">
            {{ 'courseModule.course' | translate | titlecase }}
          </h3>
          <h3 class="card-title" *ngIf="saleItemPage == 'subscription'">
            {{ 'subscriptionModule.subscription' | translate | titlecase }}
          </h3>
          <h3 class="card-title" *ngIf="saleItemPage == 'rental'">
            {{ 'rentalModule.rental' | translate | titlecase }}
          </h3>
          <h3 class="card-title" *ngIf="saleItemPage == 'multiDay'">
            {{ 'bookingModule.multiDay' | translate | titlecase }}
          </h3>
          <h3 class="card-title" *ngIf="saleItemPage == 'other'">
            {{ 'saleModule.otherProduct' | translate | titlecase }}
          </h3>
          <h3 class="card-title" *ngIf="saleItemPage == 'unpaid'">
            {{ 'saleModule.unpaidBookings' | translate }}
          </h3>
        </div>

        <div class="card-body" *ngIf="saleItemPage != 'unpaid'">
          <sale-item-create-modal
            *ngIf="saleItemPage == 'booking'"
            [isPage]="true"
            [title]="'bookingModule.booking'"
            [saleItem]="emptySaleItem"
            (pageClose)="saleItemPage = 'selectType'"
          ></sale-item-create-modal>

          <dms-table
            *ngIf="saleItemPage == 'course'"
            [isLoading]="courseIsLoading$ | async"
            [showTotal]="true"
            [tableType]="'courses'"
            (onClickRow)="onClickCourseRow($event)"
          >
          </dms-table>

          <sale-item-create-modal
            *ngIf="saleItemPage == 'subscription'"
            [isPage]="true"
            [title]="'subscriptionModule.subscription'"
            [saleItem]="emptySaleItem"
            [saleItemCreate]="'subscription'"
            [selectedCustomerPersonId]="selectedCustomerPersonId"
            (pageClose)="saleItemPage = 'selectType'"
          ></sale-item-create-modal>

          <sale-item-create-modal
            *ngIf="saleItemPage == 'rental'"
            [isPage]="true"
            [title]="'rentalModule.rental'"
            [saleItem]="emptySaleItem"
            [saleItemCreate]="'rental'"
            [customerCategoryId]="customerCategory"
            (pageClose)="saleItemPage = 'selectType'"
          ></sale-item-create-modal>

          <sale-item-create-modal
            *ngIf="saleItemPage == 'multiDay'"
            [isPage]="true"
            [saleItemCreate]="'multiple'"
            (pageClose)="saleItemPage = 'selectType'"
          ></sale-item-create-modal>

          <sale-item-create-modal
            *ngIf="saleItemPage == 'other'"
            [isPage]="true"
            [title]="'general.item'"
            [saleItem]="emptySaleItem"
            (pageClose)="saleItemPage = 'selectType'"
          ></sale-item-create-modal>
        </div>

        <div class="card-body p-0" *ngIf="saleItemPage == 'unpaid'">
          <ng-container *ngIf="unpaidBookingRows$ | async as unpaidBookingRows">
            <div class="row g-3 align-items-center border-bottom p-3">
              <div class="col-12 col-xl-5">
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend input-group-text">
                    <i role="img" class="fa fa-search" aria-hidden="true"></i>
                  </div>
                  <input
                    data-test-id="create-sale-unpaid-search-input"
                    type="search"
                    class="form-control"
                    aria-label="Search"
                    [placeholder]="'general.search' | translate"
                    (input)="onUnpaidSearch($any($event.target).value)"
                  />
                </div>
              </div>

              <div class="col-12 col-md-auto ms-xl-auto">
                <div class="d-flex align-items-center gap-2">
                  <input
                    data-test-id="create-sale-unpaid-start-date-input"
                    type="date"
                    class="form-control w-auto"
                    [value]="unpaidStartDate$ | async"
                    [min]="unpaidMinStartDate"
                    [max]="(unpaidEndDate$ | async) || unpaidMaxEndDate"
                    (change)="
                      onUnpaidStartDateChange($any($event.target).value)
                    "
                    aria-label="Start date"
                  />
                  <span class="text-muted">
                    <i
                      role="img"
                      class="fa fa-arrow-right"
                      aria-hidden="true"
                    ></i>
                  </span>
                  <input
                    data-test-id="create-sale-unpaid-end-date-input"
                    type="date"
                    class="form-control w-auto"
                    [value]="unpaidEndDate$ | async"
                    [min]="(unpaidStartDate$ | async) || unpaidMinStartDate"
                    [max]="unpaidMaxEndDate"
                    (change)="onUnpaidEndDateChange($any($event.target).value)"
                    aria-label="End date"
                  />
                </div>
              </div>

              <div class="col-12 col-md-auto text-muted text-md-end">
                {{ getUnpaidBookingRowCount(unpaidBookingRows) }}
                {{ 'general.total' | translate | lowercase }}
              </div>
            </div>

            <div class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">
                      <input
                        data-test-id="create-sale-unpaid-select-all-checkbox"
                        type="checkbox"
                        class="form-check-input"
                        aria-label="Select all unpaid bookings"
                        [checked]="areAllUnpaidRowsSelected(unpaidBookingRows)"
                        [disabled]="!unpaidBookingRows.length"
                        (change)="
                          toggleAllUnpaidRows(unpaidBookingRows, $event)
                        "
                      />
                    </th>
                    <th scope="col" class="small text-primary text-uppercase">
                      {{ 'general.status' | translate }}
                    </th>
                    <th scope="col" class="small text-primary text-uppercase">
                      {{ 'bookingModule.activity' | translate }}
                    </th>
                    <th scope="col" class="small text-primary text-uppercase">
                      {{ 'general.startDate' | translate }}
                    </th>
                    <th scope="col" class="text-end">
                      <span class="visually-hidden">Actions</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let row of unpaidBookingRows">
                    <tr
                      [ngClass]="{
                        'table-primary': row.isSerie,
                        'cursor-pointer': row.booking?.id
                      }"
                      (click)="onClickUnpaidBookingRow(row)"
                      (keyup.enter)="onClickUnpaidBookingRow(row)"
                      [attr.tabindex]="row.booking?.id ? 0 : null"
                      [attr.role]="row.booking?.id ? 'link' : null"
                    >
                      <td
                        class="align-middle"
                        (click)="$event.stopPropagation()"
                      >
                        <input
                          data-test-id="create-sale-unpaid-row-checkbox"
                          type="checkbox"
                          class="form-check-input"
                          aria-label="Select unpaid booking"
                          [checked]="isUnpaidRowSelected(row)"
                          (change)="toggleUnpaidRow(row, $event)"
                        />
                      </td>
                      <td class="align-middle">
                        <span class="badge bg-soft-danger text-danger">
                          {{ 'paymentModule.collectStatus2' | translate }}
                        </span>
                      </td>
                      <td class="align-middle">{{ row.activity }}</td>
                      <td class="align-middle">
                        <ng-container *ngIf="!row.isSerie">
                          {{
                            row.startDate
                              | date
                                : 'HH:mm - EEEE d MMM yyyy'
                                : null
                                : (selectedLanguage$ | async)
                          }}
                        </ng-container>
                        <ng-container *ngIf="row.isSerie">
                          {{ 'serieProposalModule.bookingSerie' | translate }}
                        </ng-container>
                      </td>
                      <td class="align-middle text-end">
                        <button
                          *ngIf="row.isSerie"
                          data-test-id="create-sale-unpaid-serie-toggle-button"
                          class="btn btn-ghost-secondary btn-icon btn-sm"
                          type="button"
                          aria-label="Toggle booking serie"
                          (click)="
                            $event.stopPropagation(); toggleUnpaidSerie(row)
                          "
                        >
                          <i
                            role="img"
                            class="fa"
                            [ngClass]="{
                              'fa-chevron-down': !isUnpaidSerieExpanded(row),
                              'fa-chevron-up': isUnpaidSerieExpanded(row)
                            }"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </td>
                    </tr>

                    <ng-container
                      *ngIf="row.isSerie && isUnpaidSerieExpanded(row)"
                    >
                      <tr
                        class="table-light cursor-pointer"
                        *ngFor="let child of row.children"
                        (click)="onClickUnpaidBookingRow(child)"
                        (keyup.enter)="onClickUnpaidBookingRow(child)"
                        tabindex="0"
                        role="link"
                      >
                        <td
                          class="align-middle"
                          (click)="$event.stopPropagation()"
                        >
                          <input
                            data-test-id="create-sale-unpaid-row-checkbox"
                            type="checkbox"
                            class="form-check-input"
                            aria-label="Select unpaid booking"
                            [checked]="isUnpaidRowSelected(child)"
                            (change)="toggleUnpaidRow(child, $event)"
                          />
                        </td>
                        <td class="align-middle">
                          <span class="badge bg-soft-danger text-danger">
                            {{ 'paymentModule.collectStatus2' | translate }}
                          </span>
                        </td>
                        <td class="align-middle">{{ child.activity }}</td>
                        <td class="align-middle">
                          {{
                            child.startDate
                              | date
                                : 'HH:mm - EEEE d MMM yyyy'
                                : null
                                : (selectedLanguage$ | async)
                          }}
                        </td>
                        <td></td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="createSaleFromCourses">
        <sale-item-purchase-params-form
          #salesItemsPurchase
          [params]="bookingFromCourse$ | async"
          [dataCreateSaleFromCourse]="dataForCreateCourseSale"
          [resetForm$]="resetForm$"
          [createSaleFromCourse]="createSaleFromCourses"
          (onIsAvailable)="setIsAvailable($event)"
        ></sale-item-purchase-params-form>
      </ng-container>
    </section>
    <div class="d-flex mt-5 justify-content-between">
      <button
        (click)="onClickBackButton()"
        class="btn btn-soft-primary btn-lg"
        type="button"
      >
        {{ 'general.back' | translate }}
      </button>

      <button
        data-test-id="create-sale-button-finish"
        (click)="
          saleItemPage === 'unpaid'
            ? onClickCreateUnpaidSale()
            : onClickFinishSale()
        "
        [disabled]="
          saleItemPage === 'unpaid'
            ? !selectedUnpaidParticipationIds.size || (isLoading$ | async)
            : !(saleItemPartials$ | async)?.length || (isLoading$ | async)
        "
        [hidden]="
          saleItemPage === 'unpaid' ? false : (hideFinishSaleButton$() | async)
        "
        class="btn btn-primary btn-lg"
        type="button"
      >
        {{
          saleItemPage == 'unpaid'
            ? ('bookingModule.continue' | translate)
            : ('general.finish' | translate)
        }}
      </button>
    </div>
  </div>
</div>
